import axios from '@/http.js';

export default {
    logout() {
        return axios.get(`auth/api/logout`);
    },
    validateToken(token, prod) {
        return axios.get(`auth/loginByToken?token=${token}&product=${prod}`);
    },
}